import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16","key":"svg-0"}],["path",{"d":"M8 16v-8a4 4 0 1 1 8 0v8","key":"svg-1"}],["path",{"d":"M8 10h8","key":"svg-2"}]]

/**
 * IconBaseline
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmFzZWxpbmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMjBoMTYiIC8+CiAgPHBhdGggZD0iTTggMTZ2LThhNCA0IDAgMSAxIDggMHY4IiAvPgogIDxwYXRoIGQ9Ik04IDEwaDgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/baseline
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBaseline = createReactComponent('outline', 'baseline', 'Baseline', __iconNode);

export default IconBaseline;